import { XMarkIcon } from '@heroicons/react/24/outline';
import Button from 'components/Buttons/Button';
import { useSidebarStatus } from 'containers/Sidebar/useSidebarStatus';
import React from 'react';
import 'twin.macro';

export function ButtonClose() {
  const { toggle } = useSidebarStatus();

  return (
    <Button
      tw="rounded-full px-1 py-0 bg-reverse-quiet border-transparent hover:bg-reverse-moderate focus:border-reverse-moderate"
      small
      onClick={() => toggle()}
    >
      <XMarkIcon tw="h-5 w-5 text-white!" />
    </Button>
  );
}
